import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import LoadingContainer from '../common/loadingContainer/LoadingContainer';
import { RoutePaths } from '../../Constants/Common';

const RedirectAuthPage = (): JSX.Element => {
    const { user, isAuthenticated, isLoading } = useAuth0();
    const navigate = useNavigate();

    const emailVerifiedRedirect = () => {
        navigate(RoutePaths.Home);
    };

    const verifiedUser = user?.email_verified === true;

    useEffect(() => {
        if (!isLoading && user) {
            if (verifiedUser && isAuthenticated) {
                emailVerifiedRedirect();
            } else {
                navigate(RoutePaths.Verify);
            }
        }
    }, [isLoading]);

    return (
        <>
            {isLoading && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'white'
                    }}>
                    <LoadingContainer
                        centered
                        loading
                        message='Logging in...'
                    />
                </div>
            )}
        </>
    );
};

export default RedirectAuthPage;
